import axios from "axios";
import { env } from "@/shared/config/env";
import { attachAuthInterceptor } from "./authInterceptor";

const profileClient = axios.create({
  baseURL: env.api.profile,
  headers: { "Content-Type": "application/json" },
  // API Gateway caps integrations at 30s — anything longer is a hung
  // connection that would otherwise pin submit buttons in loading forever.
  timeout: 35_000,
});

attachAuthInterceptor(profileClient);

export default profileClient;
